export const styles = {
	mainContainer: "tw:canister tw:pt-4 tw:md:pt-6",
	companyListContainer:
		"tw:flex tw:w-full tw:flex-col tw:gap-4 tw:md:gap-6 tw:px-2",
	pageLink:
		"tw:inline-flex tw:text-[#2B3440] tw:capitalize tw:pt-2.5 tw:pb-3 tw:px-4 tw:text-sm tw:font-medium tw:leading-[normal] tw:shadow-[0px_10px_16px_0px_rgba(60,57,53,0.06),0px_1px_0px_0px_rgba(60,57,53,0.04),0px_0px_8px_0px_rgba(60,57,53,0.04)] tw:rounded-lg",
	paginationContainer: "tw:mx-auto tw:my-[28px] tw:flex tw:gap-2",
	previousLink: "tw:mr-6",
	nextLink: "tw:ml-6",
	activeLink: "tw:bg-[#0B60E0] tw:text-white!",
	disabledLink: "tw:opacity-50 tw:cursor-not-allowed",
};
